export { default as VariantProduct } from './VariantProduct';